import { createFileRoute, notFound } from "@tanstack/react-router";
import { findRentalGuide } from "@/lib/rental-guides";
import { RentalGuidePage, rentalGuideHead } from "@/components/site/RentalGuidePage";

export const Route = createFileRoute("/blog/$slug")({
  loader: ({ params }) => {
    const guide = findRentalGuide(params.slug);
    if (!guide) throw notFound();
    return guide;
  },
  head: ({ loaderData }) => loaderData ? rentalGuideHead(loaderData) : { meta: [{ title: "Guide Unavailable | Avolus Cars" }, { name: "description", content: "This Avolus rental guide is unavailable." }, { property: "og:title", content: "Guide Unavailable | Avolus Cars" }, { property: "og:description", content: "This Avolus rental guide is unavailable." }, { property: "og:type", content: "website" }, { name: "twitter:card", content: "summary" }, { name: "robots", content: "noindex" }] },
  component: Guide,
});

function Guide() {
  const guide = Route.useLoaderData();
  return <RentalGuidePage guide={guide} />;
}